import type { ReactNode } from 'react';
import { Dialog, OverlayArrow, Popover as ReactAriaPopover, type PopoverProps } from 'react-aria-components';

import styles from './Popover.module.css';

export type Props = Pick<PopoverProps, 'children' | 'isOpen' | 'onOpenChange' | 'triggerRef' | 'placement'> & {
  children: ReactNode;
};

export function Popover({ children, isOpen, onOpenChange, triggerRef, placement }: Props) {
  return (
    <ReactAriaPopover
      className={styles.popover}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      triggerRef={triggerRef}
      placement={placement}
    >
      <OverlayArrow className={styles.arrow}>
        <svg width={12} height={12} viewBox="0 0 12 12">
          <path d="M0 0 L6 6 L12 0" />
        </svg>
      </OverlayArrow>
      <Dialog className={styles.dialog}>{children}</Dialog>
    </ReactAriaPopover>
  );
}
